import axios from 'axios';
import { NOTIFICATIONAPIHOME } from './config';
import DealerDataDef from '../sections/dealer/dealerdatadef';

class NotificationService {

    constructor() {
        this.GetColumns = (menuName) => (DealerDataDef(menuName));

        this.GetTopFiveNotifications = (payload) => (axios.post(`${NOTIFICATIONAPIHOME}gettopfivenotifications`, payload));

        this.GetAllNotifications = (payload) => (axios.post(`${NOTIFICATIONAPIHOME}getallnotifications`, payload));

        this.UpdateNotificationstatus = (payload) => (axios.post(`${NOTIFICATIONAPIHOME}updatenotificationstatus`, payload));

        this.GetNotificationTemplate = (payload) => (axios.post(`${NOTIFICATIONAPIHOME}getnotificationtemplate`, payload));

        this.SendNotification = (payload) => (axios.post(`${NOTIFICATIONAPIHOME}sendnotification`, payload));
    }
}
export default new NotificationService();